export const pricingPlans = [
  {
    title: "Base Subscription",
    price: "$100/mo",
    features: ["Download Lab Reports to One Place", "500 Lab Reports a month", "Email support"],
  },
  {
    title: "Additional Lab Reports",
    price: "$0.50/report",
    features: ["Unlimited Number of Users", "Supports Large Hospitals"],
    bestValue: true,
  },
  {
    title: "Setup Fee",
    price: "$100",
    features: [
      "Unlimited Historical Lab Reports",
      "Dedicated account manager",
      "4 Hours of Training and Customization",
      "Premium support",
    ],
  },
]
